"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapboxLocationMap = void 0;
var _core = require("@material-ui/core");
var _pittaDesignSystem = require("@thingsw/pitta-design-system");
var _clsx0 = _interopRequireDefault(require("clsx"));
var _detectBrowser = require("detect-browser");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = require("react-helmet");
var turf = _interopRequireWildcard(require("@turf/turf"));
var _TopRightControl = require("./TopRightControl");
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _reactVirtualized = require("react-virtualized");
var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _pittaModules = require("@thingsw/pitta-modules");
var _withStyleProvider = require("../hoc/withStyleProvider");
var _CameraListItem = require("./CameraListItem");
var _mapboxGl = _interopRequireDefault(require("!mapbox-gl"));
var _screenfull = _interopRequireDefault(require("screenfull"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //@ts-ignore
// import MapboxWorker from "mapbox-gl/dist/mapbox-gl-csp-worker";
// mapboxgl.workerClass = MapboxWorker;
_mapboxGl["default"].accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
var CAM_SOURCE_NAME = 'cam-source';
var CAM_DOT_LAYER_NAME = 'cam-dot-layer';
var CAM_DOT_LAYER = {
  id: CAM_DOT_LAYER_NAME,
  source: CAM_SOURCE_NAME,
  type: 'circle',
  paint: {
    'circle-color': 'transparent',
    'circle-translate': [0, -25]
  }
};
var useStyles = (0, _core.makeStyles)(function (theme) {
  var _appCamFilterLBtnStyl;
  return {
    root: {
      width: '100%',
      height: '100%',
      position: 'relative'
    },
    map: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden'
    },
    topControlPane: _objectSpread(_objectSpread({
      position: 'absolute',
      top: 0
    }, theme.direction === 'rtl' ? {
      left: 0
    } : {
      right: 0
    }), {}, {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: theme.spacing(1),
      overflow: 'visible',
      zIndex: 101
    }),
    gpsChip: _objectSpread(_objectSpread({
      position: 'absolute',
      top: 16
    }, theme.direction === 'rtl' ? {
      right: 16
    } : {
      left: 16
    }), {}, {
      display: 'inline-flex',
      alignItems: 'center',
      // primary[1] (#13131C) + A6 alpha
      backgroundColor: "".concat(_pittaModules.LightColors.primary['1'], "A6"),
      color: _pittaModules.LightColors.primary['0'],
      padding: '4px 8px',
      borderRadius: 4
    }),
    gpsChipFullscreen: {
      padding: '8px 12px',
      borderRadius: 8
    },
    bottomControlPane: {
      bottom: 24,
      top: 'unset',
      zIndex: 98
    },
    backBtn: _objectSpread(_objectSpread({
      position: 'absolute',
      top: 0
    }, theme.direction === 'rtl' ? {
      right: 0
    } : {
      left: 0
    }), {}, {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'visible',
      '& > button': {
        borderRadius: '50%',
        width: 40,
        height: 40,
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        },
        '& svg path': {
          fill: function fill(props) {
            return props.colors.primary['1'];
          }
        }
      }
    }),
    backIcon: _objectSpread({}, theme.direction === 'rtl' ? {
      marginRight: 4
    } : {
      marginLeft: 4
    }),
    camFilterRoot: {
      paddingBottom: 0
    },
    camFilterDiv: {
      minWidth: 311,
      padding: '0 16px'
    },
    camFilterTitle: {
      margignBottom: 6.5,
      paddingBottom: 4,
      borderBottom: function borderBottom(props) {
        return "2px solid ".concat(props.colors.primary['9']);
      }
    },
    appCamFilterTitle: {
      paddingBottom: 4,
      paddingLeft: 4
    },
    filterTitleDivider: {
      opacity: 0.3,
      borderBottom: function borderBottom(props) {
        return props.color === 'dark' ? "2px solid ".concat(props.colors.primary['2']) : "2px solid ".concat(props.colors.primary['9']);
      }
    },
    camFilterListItem: {
      display: 'flex',
      height: 48,
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    appCamFilterListItem: {
      display: 'flex',
      height: 48,
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px',
      paddingBottom: 12
    },
    renewalAppCamFilterListItem: {
      display: 'flex',
      height: 44,
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 0 8px 0'
    },
    tnpDiv: _objectSpread({}, theme.direction === 'rtl' ? {
      paddingRight: 44
    } : {
      paddingLeft: 44
    }),
    appIcon: _objectSpread({
      fontSize: 15,
      color: _pittaModules.LightColors.primary['1']
    }, theme.direction === 'rtl' ? {
      marginLeft: theme.spacing(1)
    } : {
      marginRight: theme.spacing(1)
    }),
    textTransform: {
      textTransform: 'none',
      color: function color(props) {
        return props.colors.primary['1'];
      },
      backgroundColor: function backgroundColor(props) {
        return props.color === 'dark' ? '#1E1E23' : '#FFFFFF';
      }
    },
    mobileMemuItem: {
      padding: theme.spacing(1.5, 2)
    },
    camListPaper: {
      width: 343
    },
    camListContent: {
      // minHeight: 449,
      maxHeight: 449,
      padding: '0 16px 24px',
      overflow: 'hidden'
    },
    // 10개 미만의 카메라 갯수가 리스트 팝업으로 뜰때는 상하의 크기가 자동 조절될 수 있도록 css 분리적용 (Leehj)
    camListScrollContent: {
      minHeight: 449
    },
    camListAPPMobileContent: {
      overflowY: 'auto'
    },
    camListTitle: {
      display: 'flex',
      justifyContent: 'center',
      minHeight: 31
    },
    camListHeading: {
      fontSize: '20px !important',
      color: function color(props) {
        return props.colors.primary['1'];
      }
    },
    noHover: {
      '&:hover': {
        color: function color(props) {
          return props.colors.primary['1'];
        },
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        },
        '& svg path': {
          fill: function fill(props) {
            return props.colors.primary['1'];
          }
        }
      },
      '&:active': {
        color: function color(props) {
          return props.colors.primary['7'];
        },
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        },
        '& svg path': {
          fill: function fill(props) {
            return props.colors.primary['7'];
          }
        }
      }
    },
    noFocus: {
      '&:focus': {
        color: _pittaModules.LightColors.primary['1'],
        '& svg path': {
          fill: _pittaModules.LightColors.primary['1']
        }
      }
    },
    appCamFilterModalDiv: {
      margin: 16,
      color: function color(props) {
        return props.colors.primary['1'];
      },
      backgroundColor: function backgroundColor(props) {
        return props.colors.primary['0'];
      },
      borderColor: function borderColor(props) {
        return props.colors.primary['4'];
      },
      '& svg': {
        fill: function fill(props) {
          return props.colors.primary['1'];
        }
      }
    },
    appCamFilterModalContentDiv: {
      padding: '24px 24px 32px 22px'
    },
    renewalAppCamFilterModalContentDiv: {
      padding: '0px 22px 12px 16px'
    },
    appCamFilterBtnDiv: {
      padding: '0px 15.5px 24px'
    },
    appCamFilterRBtnStyle: _defineProperty({
      minWidth: 151
    }, theme.breakpoints.down(_pittaModules.Webviewer.smallMobile), {
      minWidth: 110
    }),
    appCamFilterLBtnStyle: (_appCamFilterLBtnStyl = {
      minWidth: 151,
      color: function color(props) {
        return "".concat(props.colors.primary['1'], " !important");
      },
      backgroundColor: function backgroundColor(props) {
        return props.color === 'dark' ? '#323236 !important' : '#FFFFFF';
      },
      border: function border(props) {
        return props.color === 'dark' ? '1px solid #636367' : "1px solid ".concat(props.colors.primary['4']);
      }
    }, _defineProperty(_appCamFilterLBtnStyl, theme.breakpoints.down(_pittaModules.Webviewer.smallMobile), {
      minWidth: 110
    }), _defineProperty(_appCamFilterLBtnStyl, '&:disabled', {
      color: function color(props) {
        return props.color === 'dark' ? '#636367 !important' : "".concat(props.colors.primary['4'], " !important");
      }
    }), _defineProperty(_appCamFilterLBtnStyl, '&:hover', {
      border: function border(props) {
        return props.color === 'dark' ? '1px solid #636367' : "1px solid ".concat(props.colors.primary['4']);
      }
    }), _appCamFilterLBtnStyl),
    filterGroupDiv: {
      padding: '8px 4px 12px'
    },
    formWrap: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    formDiv: {
      display: 'flex',
      flexDirection: 'column'
    },
    appCamFilterHeaderText: {
      fontSize: '16px !important'
    },
    renewalAppCamFilterHeaderText: {
      fontSize: '18px !important'
    },
    appCamFilterHeaderDiv: {
      padding: '24px 13px 0 26px'
    },
    renewalAppCamFilterHeaderDiv: {
      padding: '12px 16px',
      height: 43,
      display: 'flex',
      alignItems: 'center'
    },
    appCamFilterHeaderBtn: {
      top: 34,
      right: 12
    },
    renewalAppCamFilterHeaderBtn: {
      top: 17.5,
      right: 16,
      width: 32,
      height: 32
    },
    checkboxRoot: {
      color: _pittaModules.LightColors.primary['4'],
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      },
      '& svg': {
        fill: function fill(props) {
          return props.color === 'dark' ? _pittaModules.LightColors.primary[2] : _pittaModules.LightColors.primary[4];
        }
      }
    },
    cameraCheckBoxLabel: {
      marginRight: 0
    },
    checkboxRootChecked: {
      '& svg': {
        fill: "".concat(_pittaModules.LightColors.primary[7], " !important")
      }
    },
    liveCamTextDiv: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: 263,
      gap: 2
    }
  };
});
var MapboxLocationMap = (0, _withStyleProvider.withStyleProvider)(function (props) {
  var _clsx9;
  var mapRef = props.mapRef,
    onLiveView = props.onLiveView,
    speedUnit = props.speedUnit,
    filteredCams = props.filteredCams,
    fullscreenIcon = props.fullscreenIcon,
    app = props.app,
    publicIcon = props.publicIcon,
    focusCam = props.focusCam,
    psn = props.psn,
    location = props.location,
    playback = props.playback,
    liveView = props.liveView,
    userState = props.userState,
    locationState = props.locationState,
    pushEventState = props.pushEventState,
    cameraState = props.cameraState,
    geofenceState = props.geofenceState,
    groupState = props.groupState,
    themeState = props.themeState,
    t = props.t,
    onClose = props.onClose,
    clearFocusCam = props.clearFocusCam,
    _onFailedLocation = props.onFailedLocation,
    setIsMapboxFullscreen = props.setIsMapboxFullscreen,
    requestZoneAllDevice = props.requestZoneAllDevice,
    resizeFlag = props.resizeFlag,
    renewal = props.renewal,
    locPerm = props.locPerm,
    isPublic = props.isPublic;
  var loadingLocation = themeState.loadingLocation,
    color = themeState.color,
    colors = themeState.colors;
  var classes = useStyles({
    color: color,
    colors: colors
  });
  var theme = (0, _core.useTheme)();
  var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
  var email = userState.email,
    userSettings = userState.userSettings;
  var gpsWS = locationState.gpsWS,
    multipleMap = locationState.multipleMap,
    gpsPsnsMyDevices = locationState.gpsPsnsMyDevices;
  var webPushEvent = pushEventState.webPushEvent;
  var clusters = cameraState.clusters,
    cameraList = cameraState.cameraList,
    publicCams = cameraState.publicCams;
  var geofences = geofenceState.geofences,
    currentGeofence = geofenceState.currentGeofence;
  var groupsList = groupState.groupsList;
  var styleChangedRef = (0, _react.useRef)(false);
  var rootDivRef = (0, _react.useRef)(null);
  var mapContainer = (0, _react.useRef)(null);
  var map = (0, _react.useRef)(null);
  var locationInfoMarker = (0, _react.useRef)();
  var markersRef = (0, _react.useRef)([]);
  var clustersRef = (0, _react.useRef)([]);
  // 내 대시캠 위치 요청했는지
  var myCamLocRequested = (0, _react.useRef)(false);
  // 내 대시캠 위치로 지도 이동시도했는지
  var initMyCamLocation = (0, _react.useRef)(false);
  //클릭된 public cam
  var clickedPublicCam = (0, _react.useRef)();
  var orientation = (0, _pittaModules.useScreenOrientation)();
  var windowSize = (0, _pittaModules.useWindowSize)();
  var publicRef = (0, _react.useRef)(null);
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    mapLoaded = _useState2[0],
    setMapLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openLayer = _useState4[0],
    setOpenLayer = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    activePublic = _useState6[0],
    setActivePublic = _useState6[1];
  // app의 경우 저장버튼을 눌러야 적용되어야 하기에 추가한 state
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    activePublicFilter = _useState8[0],
    setActivePublicFilter = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    openCamFilter = _useState0[0],
    setOpenCamFilter = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    openAppCamFilter = _useState10[0],
    setOpenAppCamFilter = _useState10[1];
  var _useState11 = (0, _react.useState)('map'),
    _useState12 = _slicedToArray(_useState11, 2),
    mapMode = _useState12[0],
    setMapMode = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    locs = _useState14[0],
    setLocs = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    modalLocs = _useState16[0],
    setModalLocs = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    openCamListModal = _useState18[0],
    setOpenCamListModal = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedGroups = _useState20[0],
    setSelectedGroups = _useState20[1];
  var _useState21 = (0, _react.useState)([]),
    _useState22 = _slicedToArray(_useState21, 2),
    filterSelectedGroups = _useState22[0],
    setFilterSelectedGroup = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    fullscreen = _useState24[0],
    setFullscreen = _useState24[1];
  var _useState25 = (0, _react.useState)(),
    _useState26 = _slicedToArray(_useState25, 2),
    mapInst = _useState26[0],
    setMapInst = _useState26[1];
  var _useState27 = (0, _react.useState)({}),
    _useState28 = _slicedToArray(_useState27, 2),
    sourceUpdate = _useState28[0],
    setSourceUpdate = _useState28[1];
  var _useState29 = (0, _react.useState)(false),
    _useState30 = _slicedToArray(_useState29, 2),
    locationLoading = _useState30[0],
    setLocationLoading = _useState30[1];
  (0, _react.useEffect)(function () {
    return function () {
      markersRef.current = [];
      setLocs([]);
    };
  }, [psn]);
  (0, _react.useEffect)(function () {
    if (!activePublic) {
      var _locationInfoMarker$c;
      (_locationInfoMarker$c = locationInfoMarker.current) === null || _locationInfoMarker$c === void 0 ? void 0 : _locationInfoMarker$c.remove();
      locationInfoMarker.current = undefined;
    }
  }, [activePublic]);
  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      var _map$current;
      map === null || map === void 0 || (_map$current = map.current) === null || _map$current === void 0 ? void 0 : _map$current.resize();
    }, 200);
    return function () {
      clearTimeout(timer);
    };
  }, [resizeFlag]);
  (0, _react.useEffect)(function () {
    if (setIsMapboxFullscreen) setIsMapboxFullscreen(fullscreen);
  }, [fullscreen]);
  (0, _react.useEffect)(function () {
    return function () {
      myCamLocRequested.current = false;
      initMyCamLocation.current = false;
    };
  }, []);
  (0, _react.useEffect)(function () {
    function exitHandler(evt) {
      var fullscreenElement =
      //@ts-ignore
      document.fullscreenElement || document.webkitCurrentFullScreenElement;
      // console.log(
      //   "aaaaaa",
      //   liveView,
      //   "exitHandler",
      //   mapRef?.current,
      //   fullscreenElement
      // );
      if ((mapRef !== null && mapRef !== void 0 && mapRef.current || rootDivRef !== null && rootDivRef !== void 0 && rootDivRef.current) && !fullscreenElement) {
        setFullscreen(false);
      }
    }
    if (_screenfull["default"].isEnabled) {
      _screenfull["default"].on('change', exitHandler);
      return function () {
        //@ts-ignore
        _screenfull["default"].off('change', exitHandler);
      };
    }
  }, [fullscreen]);

  //@ts-ignore
  window.backPressed = function () {
    if (openAppCamFilter) {
      return setOpenAppCamFilter(false);
    }
    if (openLayer) {
      return setOpenLayer(false);
    }
    if (openCamFilter) {
      return setOpenCamFilter(false);
    }
    if (openCamListModal) {
      return setOpenCamListModal(false);
    }
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  (0, _react.useEffect)(function () {
    var grps = ['notInGroup'].concat(_toConsumableArray(_lodash["default"].map(groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, function (g) {
      return g.GroupID;
    })));
    setSelectedGroups(grps);
    setFilterSelectedGroup(grps);
  }, [groupsList]);
  var MAP_STYLE = (0, _react.useMemo)(function () {
    var browser = (0, _detectBrowser.detect)();
    var style = _pittaModules.DEFAULT_MAP_STYLE;
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === 'chrome' || (browser === null || browser === void 0 ? void 0 : browser.name) === 'chromium-webview') {
      var _browser$version;
      var vstring = (_browser$version = browser === null || browser === void 0 ? void 0 : browser.version) !== null && _browser$version !== void 0 ? _browser$version : '0.0';
      var version = parseInt(vstring.split('.')[0]);
      if (version <= 76) {
        style = _pittaModules.NO_INT_MAP_STYLE;
      }
    }
    if (color === 'dark') {
      style = _pittaModules.DARKMODE_MAP_STYLE;
    }
    return style;
  }, [color]);
  var requestAllDevices = (0, _react.useCallback)(function () {
    if (!map.current || !email || multipleMap) return;
    var bounds = map.current.getBounds();
    var sw = bounds.getSouthWest();
    var ne = bounds.getNorthEast();
    if (activePublic) {
      var msg = {
        action: 'gpsZoneAllDevices',
        email: email,
        sw: "".concat(sw.lat, "_").concat(sw.lng),
        ne: "".concat(ne.lat, "_").concat(ne.lng),
        sequenceId: new Date().getTime()
      };
      gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(msg));
    } else {
      var _msg = {
        action: 'gpsPsnsMyDevices',
        email: email,
        sw: "".concat(sw.lat, "_").concat(sw.lng),
        ne: "".concat(ne.lat, "_").concat(ne.lng),
        sequenceId: new Date().getTime()
      };
      gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(_msg));
    }
  }, [email, gpsWS, multipleMap, activePublic]);
  (0, _react.useEffect)(function () {
    if (requestZoneAllDevice) {
      requestAllDevices();
    }
  }, [requestZoneAllDevice, requestAllDevices]);
  var handleLiveview = (0, _react.useCallback)(function (loc) {
    // 라이브뷰 가능한 상태 체크
    var availableLiveView = loc.isPublic && loc.share_video === 'on' || !loc.isPublic && loc.active === 'on';
    if (availableLiveView) {
      onLiveView === null || onLiveView === void 0 ? void 0 : onLiveView(loc.psn, loc.isPublic);
    }
  }, [onLiveView]);
  (0, _react.useEffect)(function () {
    if (email && gpsWS && mapLoaded && !myCamLocRequested.current) {
      if (liveView && (isPublic === undefined || isPublic === true)) {
        if (isPublic === true) {
          myCamLocRequested.current = true;
        }
        return;
      }
      if (cameraList === undefined) return;
      // liveview 모드 / playback모드에서는 위치 요청 안함
      if (!psn && !location) {
        var msg = {
          action: 'gpsPsnsMyDevices',
          email: email,
          sequenceId: new Date().getTime()
        };
        gpsWS.send(JSON.stringify(msg));
      }
      myCamLocRequested.current = true;
    }
  }, [cameraList, email, gpsWS, location, mapLoaded, psn]);

  // Live GPS unavailable — DetailPanel GpsMap 과 동일: speed === -1 또는 좌표 없음.
  // speed == null(WS push 전) 은 chip/마커 모두 숨김.
  var liveGpsUnavailable = (0, _react.useMemo)(function () {
    if (!liveView || !psn) return false;
    var found = _lodash["default"].find(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (dev) {
      return dev.device.psn === psn && dev.device.reg_category !== 'wifi';
    });
    if (found) {
      var device = found.device;
      return device.speed === null || Number(device.speed) === -1;
    }
    var cam = _lodash["default"].find(publicCams, function (c) {
      return c.psn === psn;
    });
    if (cam) {
      return cam.speed === null || Number(cam.speed) === -1;
    }
    return false;
  }, [liveView, psn, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, publicCams]);
  (0, _react.useEffect)(function () {
    if (focusCam && focusCam.login_date) {
      if (focusCam.latitude !== 'undefined' && focusCam.longitude !== 'undefined' && focusCam.latitude !== undefined && focusCam.longitude !== undefined) {
        var _map$current2;
        var lat = parseFloat(focusCam.latitude);
        var lng = parseFloat(focusCam.longitude);
        (_map$current2 = map.current) === null || _map$current2 === void 0 ? void 0 : _map$current2.setCenter([lng, lat]);
        clearFocusCam === null || clearFocusCam === void 0 ? void 0 : clearFocusCam();
      }
    }
  }, [focusCam]);

  // 카메라 한대 모드에서 줌 조절
  (0, _react.useEffect)(function () {
    if (!psn) return;
    // console.log(
    //   'myCamLocRequested.current',
    //   myCamLocRequested.current,
    //   'mapLoaded',
    //   mapLoaded,
    //   'locs',
    //   locs,
    //   'initMyCamLocation.current',
    //   initMyCamLocation.current
    // );
    if (myCamLocRequested.current && mapLoaded && locs.length > 0) {
      if (!initMyCamLocation.current) {
        var _map$current3;
        (_map$current3 = map.current) === null || _map$current3 === void 0 ? void 0 : _map$current3.jumpTo({
          center: [locs[0].lng, locs[0].lat],
          zoom: 16
        });
        initMyCamLocation.current = true;
      } else {
        var _map$current4;
        (_map$current4 = map.current) === null || _map$current4 === void 0 ? void 0 : _map$current4.jumpTo({
          center: [locs[0].lng, locs[0].lat]
        });
      }
    }
  }, [locs, mapLoaded, psn]);

  // 일반 지도 모드에서 zoom 조절
  (0, _react.useEffect)(function () {
    if (psn || playback) return;

    // console.log(
    //   "MapboxLocationMap",
    //   "myCamLocRequested.current",
    //   myCamLocRequested.current,
    //   "initMyCamLocation.current",
    //   initMyCamLocation.current,
    //   "gpsPsnsMyDevices",
    //   gpsPsnsMyDevices
    // );
    if (myCamLocRequested.current && !initMyCamLocation.current && gpsPsnsMyDevices) {
      var _cameraList$deviceLis, _cameraList$deviceLis2;
      var length = (_cameraList$deviceLis = cameraList === null || cameraList === void 0 || (_cameraList$deviceLis2 = cameraList.deviceListInfo) === null || _cameraList$deviceLis2 === void 0 ? void 0 : _cameraList$deviceLis2.length) !== null && _cameraList$deviceLis !== void 0 ? _cameraList$deviceLis : 0;
      if (length > 0) {
        //위치가 있는 디바이스가 있는지 확인
        var locDevices = _lodash["default"].filter(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (dev) {
          var device = dev.device;
          return device.latitude !== 'undefined' && device.longitude !== 'undefined' && device.latitude !== undefined && device.longitude !== undefined && device.reg_category !== 'wifi';
        });

        // console.log("MapboxLocationMap", "locDevices", locDevices);

        if (locDevices.length > 0) {
          var _map$current5;
          var minLat = 999,
            minLng = 999,
            maxLat = -999,
            maxLng = -999;
          _lodash["default"].forEach(locDevices, function (dev) {
            var device = dev.device;
            if (device.latitude !== 'undefined' && device.longitude !== 'undefined' && device.latitude !== undefined && device.longitude !== undefined) {
              var lat = parseFloat(device.latitude);
              var lng = parseFloat(device.longitude);
              minLat = Math.min(lat, minLat);
              minLng = Math.min(lng, minLng);
              maxLat = Math.max(lat, maxLat);
              maxLng = Math.max(lng, maxLng);
            }
          });
          (_map$current5 = map.current) === null || _map$current5 === void 0 ? void 0 : _map$current5.fitBounds([[minLng, minLat],
          // southwestern corner of the bounds
          [maxLng, maxLat] // northeastern corner of the bounds
          ],
          // 13162 - 패딩이 커서 fitBounds가 안되는 문제가 생겨 padding을 줄임
          {
            padding: app ? 70 : 100,
            duration: 0,
            animate: false,
            maxZoom: 16
          });
        } else {
          requestAllDevices();
        }
        initMyCamLocation.current = true;
      } else {
        requestAllDevices();
        initMyCamLocation.current = true;
      }
    }
  }, [app, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, location, playback, psn, gpsPsnsMyDevices, requestAllDevices]);

  // 모달 닫힐때, 현재 위치의 디바이스 재요청
  (0, _react.useEffect)(function () {
    if (!multipleMap) {
      requestAllDevices();
    }
  }, [multipleMap, requestAllDevices]);
  (0, _react.useEffect)(function () {
    if (!mapInst) return;
    if (!mapLoaded) return;
    // console.log(
    //   "MapboxLocationMap",
    //   "location",
    //   location,
    //   initMyCamLocation.current
    // );
    if (!location) {
      // mantis - 13722, GPS 수신이 끊어지면 끊어진 위치를 지도에 표시(Hongcs)
      // map.current?.jumpTo({
      //   center: DEFAULT_LOCATION,
      //   zoom: DEFAULT_ZOOM,
      // });
      // setLocs([]);
      // initMyCamLocation.current = false;
      return;
    }
    setLocs([location]);
    if (!initMyCamLocation.current) {
      var _map$current6;
      // console.log("MapboxLocationMap", "jumpTo - 1");
      (_map$current6 = map.current) === null || _map$current6 === void 0 ? void 0 : _map$current6.jumpTo({
        center: [location.lng, location.lat],
        zoom: 16
      });
      initMyCamLocation.current = true;
    } else {
      var _map$current7;
      // console.log("MapboxLocationMap", "jumpTo - 2");
      (_map$current7 = map.current) === null || _map$current7 === void 0 ? void 0 : _map$current7.jumpTo({
        center: [location.lng, location.lat]
      });
    }
  }, [location]);
  (0, _react.useEffect)(function () {
    if (!psn) return;
    var found = _lodash["default"].find(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (dev) {
      return dev.device.psn === psn && dev.device.reg_category !== 'wifi';
    });
    // console.log("MapboxLocationMap", "update with psn", psn, "found", found);
    if (found) {
      var _device$dir_angle;
      var device = found.device;
      if (device.latitude === 'undefined' || device.longitude === 'undefined' || device.latitude === undefined || device.longitude === undefined) {
        return;
      }
      // 라이브뷰에서도 speed === -1(GPS만·속도 없음)이면 마커를 둔다. 공개/Blackvue 등에서 여기로 오면 조기 return 시 마커가 비게 된다.
      var lat = parseFloat(device.latitude);
      var lng = parseFloat(device.longitude);
      setLocs([{
        lat: lat,
        lng: lng,
        heading: parseFloat((_device$dir_angle = device.dir_angle) !== null && _device$dir_angle !== void 0 ? _device$dir_angle : '0'),
        psn: device.psn,
        name: device.dev_name,
        speed: device.speed,
        mode: device.mode,
        model: device.model,
        active: device.active,
        agree_gps: device.agree_gps,
        profile_img: device.profile_img,
        pfofile_img_v2: device.profile_img_v2,
        isPublic: false,
        isEvent: device.psn === (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn)
      }]);
      if (webPushEvent) {
        var timerId = setInterval(function () {
          setLocs(function (ls) {
            var found = _lodash["default"].find(ls, function (loc) {
              return loc.psn === (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn);
            });
            return _lodash["default"].chain(ls).filter(function (loc) {
              return loc.psn !== (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn);
            }).concat(found ? [_objectSpread(_objectSpread({}, found), {}, {
              isEvent: !found.isEvent
            })] : []).compact().value();
          });
        }, 500);
        return function () {
          clearTimeout(timerId);
        };
      }
    } else {
      var _cam$dir_angle;
      var cam = _lodash["default"].find(publicCams, function (cam) {
        return cam.psn === psn;
      });
      // console.log(
      //   "MapboxLocationMap",
      //   "liveView",
      //   liveView,
      //   "psn",
      //   psn,
      //   "public",
      //   "update with psn",
      //   psn,
      //   "cam",
      //   cam
      // );
      if (!cam) {
        setLocs([]);
        return;
      }
      if (!Number.isFinite(cam.lat) || !Number.isFinite(cam.lng)) {
        return;
      }
      setLocs([{
        lat: cam.lat,
        lng: cam.lng,
        heading: parseFloat((_cam$dir_angle = cam.dir_angle) !== null && _cam$dir_angle !== void 0 ? _cam$dir_angle : '0'),
        psn: cam.psn,
        name: cam.dev_name,
        speed: cam.speed,
        mode: cam.mode,
        active: cam.active,
        profile_img: cam.profile_img,
        profile_img_v2: cam.profile_img_v2,
        isPublic: true,
        share_dev_name: cam.share_dev_name,
        share_location: cam.share_gps,
        share_video: cam.share_video
      }]);
    }
  }, [cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, psn, publicCams, webPushEvent, webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn, liveView]);
  (0, _react.useEffect)(function () {
    var _map$current8;
    // psn이 주어진 경우 다른곳에서 처리
    if (psn || playback) return;

    // 클러스터 모드인 경우 location 추가 안함
    if (_lodash["default"].keys(clusters).length > 0) {
      setLocs([]);
      return;
    }
    var found = _lodash["default"].find(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (dev) {
      return dev.device.psn === (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn);
    });
    var bounds = (_map$current8 = map.current) === null || _map$current8 === void 0 ? void 0 : _map$current8.getBounds();
    var myCams = _lodash["default"].chain(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo).map(function (cam) {
      var _device$speed;
      var device = cam.device;
      if (device.latitude === 'undefined' || device.longitude === 'undefined') {
        return undefined;
      }
      if (liveView && parseFloat((_device$speed = device.speed) !== null && _device$speed !== void 0 ? _device$speed : '-1') === -1) {
        return undefined;
      }
      var filteredPsns = _lodash["default"].map(filteredCams, function (cam) {
        return cam.psn;
      });
      if (filteredCams && !_lodash["default"].includes(filteredPsns, device.psn)) {
        return undefined;
      }
      if (device.latitude && device.longitude) {
        var _device$dir_angle2;
        var lat = parseFloat(device.latitude);
        var lng = parseFloat(device.longitude);
        if (bounds && !bounds.contains([lng, lat])) {
          return undefined;
        }
        return {
          lat: lat,
          lng: lng,
          heading: parseFloat((_device$dir_angle2 = device.dir_angle) !== null && _device$dir_angle2 !== void 0 ? _device$dir_angle2 : '0'),
          psn: device.psn,
          name: device.dev_name,
          speed: device.speed,
          mode: device.mode,
          model: device.model,
          active: device.active,
          agree_gps: device.agree_gps,
          profile_img: device.profile_img,
          profile_img_v2: device.profile_img_v2,
          isPublic: false,
          isEvent: device.psn === (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn)
        };
      }
      return undefined;
    }).compact().value();
    var publics = activePublic ? _lodash["default"].chain(publicCams).filter(function (cam) {
      return cam.active === 'on';
    }).map(function (cam) {
      var _cam$dir_angle2;
      if (bounds && !bounds.contains([cam.lng, cam.lat])) {
        return undefined;
      }
      return {
        lat: cam.lat,
        lng: cam.lng,
        heading: parseFloat((_cam$dir_angle2 = cam.dir_angle) !== null && _cam$dir_angle2 !== void 0 ? _cam$dir_angle2 : '0'),
        psn: cam.psn,
        name: cam.dev_name,
        speed: cam.speed,
        mode: cam.mode,
        active: cam.active,
        profile_img: cam.profile_img,
        profile_img_v2: cam.profile_img_v2,
        isPublic: true,
        share_dev_name: cam.share_dev_name,
        share_location: cam.share_gps,
        share_video: cam.share_video
      };
    }).compact().value() : [];
    if (app) {
      // 그룹에 속해있는 캠
      var filterGroupCam = _lodash["default"].map(_lodash["default"].filter(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (camera) {
        return _lodash["default"].find(selectedGroups, function (g) {
          return g === camera.groupManagementID;
        });
      }), function (f) {
        return f.device.psn;
      });

      // 그룹에 속해있지 않은 캠
      var notInGroupCam = _lodash["default"].map(_lodash["default"].filter(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (camera) {
        return !_lodash["default"].find(groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, function (g) {
          return _lodash["default"].find(g.DashCamUser, function (d) {
            return d.PSN === camera.device.psn;
          });
        });
      }), function (f) {
        return f.device.psn;
      });

      // 지도상에 표시될 나의 캠
      var filterMyCams = _lodash["default"].filter(myCams, function (c) {
        if (_lodash["default"].includes(filterGroupCam, c.psn)) {
          return c;
        }
        if (_lodash["default"].includes(selectedGroups, 'notInGroup') && _lodash["default"].includes(notInGroupCam, c.psn)) {
          return c;
        }
      });

      // 지도상에 표시될 캠
      setLocs([].concat(_toConsumableArray(filterMyCams), _toConsumableArray(publics)));
    } else {
      setLocs([].concat(_toConsumableArray(myCams), _toConsumableArray(publics)));
    }
    if (found) {
      var timerId = setInterval(function () {
        setLocs(function (ls) {
          var found = _lodash["default"].find(ls, function (loc) {
            return loc.psn === (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn);
          });
          return _lodash["default"].chain(ls).filter(function (loc) {
            return loc.psn !== (webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn);
          }).concat(found ? _objectSpread(_objectSpread({}, found), {}, {
            isEvent: !found.isEvent
          }) : []).compact().value();
        });
      }, 500);
      return function () {
        clearTimeout(timerId);
      };
    }
  }, [activePublic, app, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, clusters, filterSelectedGroups, filteredCams, groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, location, playback, psn, publicCams, selectedGroups, webPushEvent === null || webPushEvent === void 0 ? void 0 : webPushEvent.psn]);

  // 클러스터 그리기
  (0, _react.useEffect)(function () {
    var _clusters$myzone, _clusters$zone;
    if (map.current === null) return;

    // 지도에 그려지 있는 마커
    var drawnMarkers = clustersRef.current;
    var zones = _lodash["default"].chain((_clusters$myzone = clusters === null || clusters === void 0 ? void 0 : clusters.myzone) !== null && _clusters$myzone !== void 0 ? _clusters$myzone : []).map(function (zone) {
      return _objectSpread(_objectSpread({}, zone), {}, {
        myzone: true
      });
    }).concat((_clusters$zone = clusters === null || clusters === void 0 ? void 0 : clusters.zone) !== null && _clusters$zone !== void 0 ? _clusters$zone : []).value();
    var exists = _lodash["default"].chain(drawnMarkers).intersectionWith(zones, function (a, b) {
      return _lodash["default"].isEqual(a.zone, b);
    }).value();
    var deleted = _lodash["default"].chain(drawnMarkers).differenceWith(zones, function (a, b) {
      return _lodash["default"].isEqual(a.zone, b);
    }).value();
    var added = _lodash["default"].chain(zones).differenceWith(drawnMarkers, function (a, b) {
      return _lodash["default"].isEqual(a, b.zone);
    }).value();

    // console.log(
    //   "MapboxLocationMap",
    //   "zones",
    //   zones,
    //   "exists",
    //   exists,
    //   "deleted",
    //   deleted,
    //   "added",
    //   added
    // );

    var addedMarkers = _lodash["default"].chain(added)
    //@ts-ignore
    .map(function (zone) {
      return (0, _pittaModules.makeClusterMarker)(map.current, zone);
    }).value();
    _lodash["default"].chain(deleted).map(function (marker) {
      return marker.remove();
    }).value();
    clustersRef.current = [].concat(_toConsumableArray(exists), _toConsumableArray(addedMarkers));
  }, [clusters]);

  // 캠 마커 그리기
  (0, _react.useEffect)(function () {
    // console.log(
    //   "MapboxLocationMap",
    //   "liveView",
    //   liveView,
    //   "psn",
    //   psn,
    //   "mapInst",
    //   mapInst,
    //   "sourceUpdate",
    //   sourceUpdate
    // );
    if (!mapInst) return;
    if (!sourceUpdate) return;

    // 지도에 그려지 있는 마커
    var drawnMarkers = markersRef.current;

    // 그냥 놔두면 되는 psn
    var exists = _lodash["default"].chain(drawnMarkers).intersectionWith(locs, function (a, b) {
      return _lodash["default"].isEqual(a.loc, b);
    }).value();
    var deleted = _lodash["default"].chain(drawnMarkers).differenceWith(locs, function (a, b) {
      return _lodash["default"].isEqual(a.loc, b);
    }).value();
    var added = _lodash["default"].chain(locs).differenceWith(drawnMarkers, function (a, b) {
      return _lodash["default"].isEqual(a, b.loc);
    }).value();
    var source = mapInst.getSource(CAM_SOURCE_NAME);

    // console.log(
    //   "MapboxLocationMap",
    //   "liveView",
    //   liveView,
    //   "psn",
    //   psn,
    //   "locations",
    //   locs,
    //   "exists",
    //   exists,
    //   "deleted",
    //   deleted,
    //   "added",
    //   added,
    //   "source",
    //   source
    // );

    if (source) {
      source.setData(turf.featureCollection(_lodash["default"].map(locs, function (loc) {
        return {
          type: 'Feature',
          properties: loc,
          geometry: {
            type: 'Point',
            coordinates: [loc.lng, loc.lat]
          }
        };
      })));
    }
    var options = {
      speedUnit: speedUnit !== null && speedUnit !== void 0 ? speedUnit : userSettings === null || userSettings === void 0 ? void 0 : userSettings.velocityUnit
    };
    var addedMarkers = _lodash["default"].chain(added).map(function (loc) {
      console.log('MapboxLocationMap', 'psn', psn, 'location', location);
      if (psn || location) {
        return (0, _pittaModules.makeLiveviewMarker)(mapInst, loc, options);
      }
      console.log('MapboxLocationMap', 'loc', loc, 'options', _objectSpread(_objectSpread({}, options), {}, {
        showProfile: renewal ? true : false
      }));
      return (0, _pittaModules.makeLocationMarker)(mapInst, loc, _objectSpread(_objectSpread({}, options), {}, {
        showProfile: renewal ? true : false,
        renewal: renewal
      }));
    }).value();
    _lodash["default"].chain(deleted).map(function (marker) {
      return marker.remove();
    }).value();
    markersRef.current = [].concat(_toConsumableArray(exists), _toConsumableArray(addedMarkers));
  }, [location, locs, psn, speedUnit, userSettings === null || userSettings === void 0 ? void 0 : userSettings.velocityUnit, sourceUpdate, mapInst]);
  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      var _map$current9;
      map === null || map === void 0 || (_map$current9 = map.current) === null || _map$current9 === void 0 ? void 0 : _map$current9.resize();
    }, 200);
    var timer2 = setTimeout(function () {
      var _map$current0;
      map === null || map === void 0 || (_map$current0 = map.current) === null || _map$current0 === void 0 ? void 0 : _map$current0.resize();
    }, 400);
    var timer3 = setTimeout(function () {
      var _map$current1;
      map === null || map === void 0 || (_map$current1 = map.current) === null || _map$current1 === void 0 ? void 0 : _map$current1.resize();
    }, 600);
    return function () {
      clearTimeout(timer);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [orientation, windowSize, fullscreen]);
  var initSources = (0, _react.useCallback)(function () {
    if (!map.current.getSource(CAM_SOURCE_NAME)) {
      map.current.addSource(CAM_SOURCE_NAME, {
        type: 'geojson',
        data: turf.featureCollection([])
      });
    }
  }, []);
  var initLayers = (0, _react.useCallback)(function () {
    if (!map.current.getLayer(CAM_DOT_LAYER_NAME)) {
      map.current.addLayer(CAM_DOT_LAYER);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!mapContainer.current) return;
    console.log('MapboxLocationMap', 'initmap', map.current);
    // initialize map only once
    if (map.current === null) {
      var options = {
        container: mapContainer.current,
        style: MAP_STYLE,
        pitchWithRotate: false,
        dragRotate: false,
        touchPitch: false,
        center: _pittaModules.DEFAULT_LOCATION,
        zoom: _pittaModules.DEFAULT_ZOOM
      };
      console.log('MapboxLocationMap', 'initmap - 2', options);
      map.current = new _mapboxGl["default"].Map(options);
    }
    if (map.current !== null) {
      var onLoad = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _map$current10;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (map.current) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                (_map$current10 = map.current) === null || _map$current10 === void 0 ? void 0 : _map$current10.resize();
                _context.next = 5;
                return (0, _pittaModules.sleep)(500);
              case 5:
                setMapLoaded(true);
                initSources();
                initLayers();
                (0, _pittaModules.initGeofenceSourcesAndLayers)(map.current);
                setMapInst(map.current);
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function onLoad() {
          return _ref.apply(this, arguments);
        };
      }();
      var onIdle = function onIdle() {
        // console.log(
        //   "MapboxLocationMap",
        //   "liveview",
        //   liveView,
        //   "psn",
        //   psn,
        //   "onIdle",
        //   "map.current",
        //   map.current,
        //   "styleChangedRef.current",
        //   styleChangedRef.current
        // );
        if (!map.current) return;
        if (styleChangedRef.current) {
          styleChangedRef.current = false;
          initSources();
          initLayers();
          setSourceUpdate({});
        }
      };
      var onMoveEnd = _lodash["default"].debounce(function () {
        // console.log("MapboxLocationMap", "onMoveEnd", psn, multipleMap);
        if (!map.current) return;
        if (myCamLocRequested.current && email) {
          if (!psn && !multipleMap) {
            requestAllDevices();
          }
        }
        var found = _lodash["default"].find(publicCams, function (c) {
          var _clickedPublicCam$cur;
          return c.psn === ((_clickedPublicCam$cur = clickedPublicCam.current) === null || _clickedPublicCam$cur === void 0 ? void 0 : _clickedPublicCam$cur.psn);
        });
        console.log('publicCams', publicCams, 'clickedPublicCam', clickedPublicCam.current);
        if (!found) {
          var _locationInfoMarker$c2;
          (_locationInfoMarker$c2 = locationInfoMarker.current) === null || _locationInfoMarker$c2 === void 0 ? void 0 : _locationInfoMarker$c2.remove();
          locationInfoMarker.current = undefined;
          clickedPublicCam.current = undefined;
        } else {
          var _map$current11;
          var bounds = (_map$current11 = map.current) === null || _map$current11 === void 0 ? void 0 : _map$current11.getBounds();
          var l = new _mapboxGl["default"].LngLat(found.lng, found.lat);
          if (!bounds.contains(l)) {
            var _locationInfoMarker$c3;
            (_locationInfoMarker$c3 = locationInfoMarker.current) === null || _locationInfoMarker$c3 === void 0 ? void 0 : _locationInfoMarker$c3.remove();
            locationInfoMarker.current = undefined;
            clickedPublicCam.current = undefined;
          }
        }
      }, 100, {
        trailing: true
      });
      var onClickMap = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
          var _map$current12, _features$length;
          var width, height, _e$point, x, y, features, _features$, loc;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                width = 40;
                height = 40;
                _e$point = e.point, x = _e$point.x, y = _e$point.y;
                console.log('onClickMap', 'map.current.getLayer(CAM_DOT_LAYER_NAME)', map.current.getLayer(CAM_DOT_LAYER_NAME));
                features = (_map$current12 = map.current) === null || _map$current12 === void 0 ? void 0 : _map$current12.queryRenderedFeatures([[x - width / 2, y - height / 2], [x + width / 2, y + height / 2]], {
                  layers: [CAM_DOT_LAYER_NAME]
                });
                if (locationInfoMarker.current) {
                  locationInfoMarker.current.remove();
                }
                if ((features === null || features === void 0 ? void 0 : features.length) === 1) {
                  loc = features === null || features === void 0 || (_features$ = features[0]) === null || _features$ === void 0 ? void 0 : _features$.properties;
                  if (loc) {
                    if (loc.share_video === 'off') {
                      locationInfoMarker.current = (0, _pittaModules.makeLocationOnlyLabel)(
                      //@ts-ignore
                      map.current, loc, t);
                      clickedPublicCam.current = loc;
                    } else {
                      handleLiveview(loc);
                    }
                  }
                } else if (((_features$length = features === null || features === void 0 ? void 0 : features.length) !== null && _features$length !== void 0 ? _features$length : 0) > 1) {
                  setModalLocs(_lodash["default"].map(features, function (f) {
                    return f.properties;
                  }));
                  setOpenCamListModal(true);
                }
                // console.log("MapboxLocationMap", "features", features);
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function onClickMap(_x) {
          return _ref2.apply(this, arguments);
        };
      }();
      map.current.touchZoomRotate.disableRotation();
      map.current.on('load', onLoad);
      map.current.on('idle', onIdle);
      map.current.on('moveend', onMoveEnd);
      map.current.on('click', onClickMap);
      map.current.on('', onClickMap);
      return function () {
        var _map$current13, _map$current14, _map$current15, _map$current16;
        (_map$current13 = map.current) === null || _map$current13 === void 0 ? void 0 : _map$current13.off('load', onLoad);
        (_map$current14 = map.current) === null || _map$current14 === void 0 ? void 0 : _map$current14.off('idle', onIdle);
        (_map$current15 = map.current) === null || _map$current15 === void 0 ? void 0 : _map$current15.off('moveend', onMoveEnd);
        (_map$current16 = map.current) === null || _map$current16 === void 0 ? void 0 : _map$current16.off('click', onClickMap);
      };
    }
  }, [MAP_STYLE, email, handleLiveview, multipleMap, psn, requestAllDevices, t]);
  (0, _react.useEffect)(function () {
    // mantis - 85, playback, liveView화면인 경우 geofence표시하지 않음(Leehj)
    if (!mapInst || playback || liveView) return;
    (0, _pittaModules.updateGeofence)(mapInst, geofences, 'view', currentGeofence, true);
  }, [currentGeofence, geofences, liveView, mapInst, playback]);

  // 모바일 화면 가로, 세로 모드 변경 시 지도 리사이즈
  // useEffect(() => {
  //   const handleOrientationChange = () => {
  //     // 지도 리사이즈 딜레이 적용
  //     setTimeout(() => {
  //       map.current?.resize();
  //     }, 50);
  //   };

  //   if (window) {
  //     window.addEventListener("orientationchange", handleOrientationChange);
  //   }

  //   return () => {
  //     window.removeEventListener(
  //       "orientationchange",
  //       handleOrientationChange
  //     );
  //   };
  // }, []);

  var handleFullscreen = (0, _react.useCallback)(function () {
    // console.log(
    //   "aaaaaa",
    //   "handleFullscreen",
    //   fullscreen,
    //   rootDivRef?.current,
    //   mapRef?.current
    // );
    // if (iosBrowser) {
    //   setFullscreen((f) => !f);
    // } else {
    //   let elementToSendFullscreen: HTMLDivElement | null =
    //     mapRef?.current ?? rootDivRef.current;
    //   if (elementToSendFullscreen) {
    //     toggleFullscreen(elementToSendFullscreen);
    //     //@ts-ignore
    //     setFullscreen(elementToSendFullscreen.fullscreen);

    //     if (app) {
    //       //@ts-ignore
    //       if (elementToSendFullscreen.fullscreen) {
    //         if (
    //           browserName === "ios-webview" &&
    //           //@ts-ignore
    //           webkit.messageHandlers.enableRotate
    //         ) {
    //           //@ts-ignore
    //           webkit.messageHandlers.enableRotate.postMessage({});
    //         }
    //         if (
    //           browserName === "chromium-webview" &&
    //           //@ts-ignore
    //           window.Webviewer?.enableRotate
    //         ) {
    //           //@ts-ignore
    //           window.Webviewer?.enableRotate?.();
    //         }
    //       } else {
    //         if (
    //           browserName === "ios-webview" &&
    //           //@ts-ignore
    //           webkit.messageHandlers.disableRotate
    //         ) {
    //           //@ts-ignore
    //           webkit.messageHandlers.disableRotate.postMessage({});
    //         }
    //         if (
    //           browserName === "chromium-webview" &&
    //           //@ts-ignore
    //           window.Webviewer?.disableRotate
    //         ) {
    //           //@ts-ignore
    //           window.Webviewer?.disableRotate?.();
    //         }
    //       }
    //     }
    //   }
    // }

    if (app) {
      if (fullscreen) {
        if (rootDivRef !== null && rootDivRef !== void 0 && rootDivRef.current) {
          (0, _pittaModules.exitFullscreen)(rootDivRef.current);
          setFullscreen(false);
        }
      } else {
        if (rootDivRef !== null && rootDivRef !== void 0 && rootDivRef.current) {
          (0, _pittaModules.requestFullscreen)(rootDivRef.current);
          setFullscreen(true);
        }
      }
    } else {
      if (fullscreen) {
        if (mapRef !== null && mapRef !== void 0 && mapRef.current) {
          (0, _pittaModules.exitFullscreen)(mapRef.current);
          setFullscreen(false);
        } else if (rootDivRef !== null && rootDivRef !== void 0 && rootDivRef.current) {
          (0, _pittaModules.exitFullscreen)(rootDivRef.current);
          setFullscreen(false);
        }
      } else {
        if (rootDivRef !== null && rootDivRef !== void 0 && rootDivRef.current) {
          (0, _pittaModules.requestFullscreen)(rootDivRef.current);
          setFullscreen(true);
        }
      }
    }
    // if (mapRef?.current) {
    //   if (isFullscreen(mapRef.current)) {
    //     exitFullscreen(mapRef.current);
    //     // dispatch(setFullscreen(false));
    //     // setfullscreen(false);
    //     // setOpenTooltip(false);
    //     // changePortrait();
    //   } else {
    //     requestFullscreen(mapRef.current);
    //     // dispatch(setFullscreen(true));
    //     // setfullscreen(true);
    //     // setOpenTooltip(true);
    //     // changeLandscape();
    //   }
    // }
  }, [fullscreen]);
  (0, _react.useEffect)(function () {
    var _map$current17;
    map === null || map === void 0 || (_map$current17 = map.current) === null || _map$current17 === void 0 ? void 0 : _map$current17.resize();
  }, [fullscreen]);

  // app일 때 출력되는 카메라 필터 마크업 (Leehj)
  var appCamFilterMarkup = (0, _react.useMemo)(function () {
    var notInGroup = _lodash["default"].filter(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (camera) {
      return !_lodash["default"].find(groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, function (g) {
        return _lodash["default"].find(g.DashCamUser, function (d) {
          return d.PSN === camera.device.psn;
        });
      });
    });
    var grps = ['notInGroup'].concat(_toConsumableArray(_lodash["default"].map(groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, function (g) {
      return g.GroupID;
    })));
    if (renewal) {
      return /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
        open: openAppCamFilter,
        onClose: function onClose() {
          setOpenAppCamFilter(false);
        },
        heading: t('Filter'),
        headerBtn: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
          onClick: function onClick() {
            setOpenAppCamFilter(false);
          },
          style: {
            marginRight: 4
          }
        }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)),
        className: classes.appCamFilterModalDiv,
        headingTextClassName: classes.renewalAppCamFilterHeaderText,
        headerBtnClassName: classes.renewalAppCamFilterHeaderBtn,
        titleClassName: classes.renewalAppCamFilterHeaderDiv,
        actionClassName: classes.appCamFilterBtnDiv,
        RButtonClassName: classes.appCamFilterRBtnStyle,
        LButtonClassName: classes.appCamFilterLBtnStyle,
        content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginBottom: 20
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.renewalAppCamFilterListItem
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
          htmlColor: colors.primary['4'],
          category: "Default",
          variant: "Body"
        }, t('My Cloud Cameras Only')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Switch, {
          checked: true,
          disabled: true
        }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.renewalAppCamFilterListItem
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.liveCamTextDiv
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
          category: "Default",
          variant: "Body"
        }, t('Live Broadcast Cameras')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
          category: "Default",
          variant: "Caption",
          htmlColor: colors.primary['2']
        }, t('*Live Broadcast Cameras_'))), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Switch, {
          checked: activePublic,
          onChange: function onChange(_e, checked) {
            setActivePublic(checked);
          }
        }))))
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
      open: openAppCamFilter,
      onClose: function onClose() {
        setOpenAppCamFilter(false);
        setFilterSelectedGroup(selectedGroups);
        setActivePublicFilter(activePublic);
      },
      onClickPositive: function onClickPositive() {
        setSelectedGroups(filterSelectedGroups);
        setActivePublic(activePublicFilter);
        setOpenAppCamFilter(false);
      },
      onClickNegative: function onClickNegative() {
        setFilterSelectedGroup(grps);
        setActivePublicFilter(true);
      },
      LButtonDisabled: activePublicFilter && filterSelectedGroups.length === grps.length,
      heading: t('Filter'),
      headingIcon: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
        onClick: function onClick() {
          setOpenAppCamFilter(false);
          setFilterSelectedGroup(selectedGroups);
          setActivePublicFilter(activePublic);
        },
        style: {
          marginRight: 4
        }
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)),
      headerBtn: /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        control: /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
          classes: {
            root: (0, _clsx0["default"])(classes.checkboxRoot, _defineProperty({}, classes.checkboxRootChecked, activePublicFilter && filterSelectedGroups.length === grps.length))
          },
          checked: activePublicFilter && filterSelectedGroups.length === grps.length,
          color: "primary",
          onChange: function onChange(_e, checked) {
            if (!checked) {
              setFilterSelectedGroup([]);
              setActivePublicFilter(false);
            } else {
              setFilterSelectedGroup(grps);
              setActivePublicFilter(true);
            }
          },
          disableRipple: true
        }),
        label: ""
      }),
      className: classes.appCamFilterModalDiv,
      headingTextClassName: classes.appCamFilterHeaderText,
      headerBtnClassName: classes.appCamFilterHeaderBtn,
      titleClassName: classes.appCamFilterHeaderDiv,
      contentClassName: classes.appCamFilterModalContentDiv,
      actionClassName: classes.appCamFilterBtnDiv,
      RButtonClassName: classes.appCamFilterRBtnStyle,
      LButtonClassName: classes.appCamFilterLBtnStyle,
      content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.appCamFilterTitle
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "SmallBold",
        htmlColor: _pittaModules.LightColors.primary['7']
      }, t('Public'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.filterTitleDivider
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.appCamFilterListItem
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Body"
      }, t('BlackVue Live Camera')), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        className: classes.cameraCheckBoxLabel,
        control: /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
          classes: {
            root: (0, _clsx0["default"])(classes.checkboxRoot, _defineProperty({}, classes.checkboxRootChecked, activePublicFilter))
          },
          checked: activePublicFilter,
          color: "primary",
          onChange: function onChange(_e, checked) {
            setActivePublicFilter(checked);
          },
          disableRipple: true
        }),
        label: ""
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.appCamFilterTitle
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "SmallBold",
        htmlColor: _pittaModules.LightColors.primary['7']
      }, t('My cameras'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.filterTitleDivider
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.filterGroupDiv,
        onClick: function onClick() {
          var exists = _lodash["default"].includes(filterSelectedGroups, 'notInGroup');
          if (exists) {
            setFilterSelectedGroup(function (groups) {
              return _toConsumableArray(_lodash["default"].filter(groups, function (gr) {
                return gr !== 'notInGroup';
              }));
            });
          } else {
            setFilterSelectedGroup(function (groups) {
              return [].concat(_toConsumableArray(groups), ['notInGroup']);
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.formWrap
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.formDiv
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Body"
      }, t('No groups')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Small",
        htmlColor: _pittaModules.LightColors.primary['2']
      }, t('n cameras', {
        n: notInGroup.length
      }))), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        color: "primary",
        classes: {
          root: (0, _clsx0["default"])(classes.checkboxRoot, _defineProperty({}, classes.checkboxRootChecked, _lodash["default"].includes(filterSelectedGroups, 'notInGroup')))
        },
        checked: _lodash["default"].includes(filterSelectedGroups, 'notInGroup')
      }))), _lodash["default"].chain(groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList).filter(function (g) {
        return !!g.DashCamUser && g.DashCamUser.length > 0;
      }).map(function (g, indx) {
        var _g$DashCamUser$length, _g$DashCamUser;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "filter-group-".concat(indx),
          className: classes.filterGroupDiv,
          onClick: function onClick() {
            var exists = _lodash["default"].includes(filterSelectedGroups, g.GroupID);
            if (exists) {
              setFilterSelectedGroup(function (groups) {
                return _toConsumableArray(_lodash["default"].filter(groups, function (gr) {
                  return gr !== g.GroupID;
                }));
              });
            } else {
              setFilterSelectedGroup(function (groups) {
                return [].concat(_toConsumableArray(groups), [g.GroupID]);
              });
            }
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.formWrap
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.formDiv
        }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
          category: "Default",
          variant: "Body"
        }, g.GroupName), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
          category: "Default",
          variant: "Small",
          htmlColor: _pittaModules.LightColors.primary['2']
        }, t('n cameras', {
          n: (_g$DashCamUser$length = (_g$DashCamUser = g.DashCamUser) === null || _g$DashCamUser === void 0 ? void 0 : _g$DashCamUser.length) !== null && _g$DashCamUser$length !== void 0 ? _g$DashCamUser$length : 0
        }))), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
          color: "primary",
          classes: {
            root: classes.checkboxRoot
          },
          checked: _lodash["default"].includes(filterSelectedGroups, g.GroupID)
        })));
      }).value()),
      LButton: t('Reset'),
      RButton: t('OK')
    });
  }, [cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, openAppCamFilter, activePublicFilter, filterSelectedGroups, t, classes.checkboxRoot, classes.appCamFilterModalDiv, classes.appCamFilterHeaderText, classes.appCamFilterHeaderBtn, classes.appCamFilterHeaderDiv, classes.appCamFilterModalContentDiv, classes.appCamFilterBtnDiv, classes.appCamFilterLBtnStyle, classes.appCamFilterRBtnStyle, classes.appCamFilterTitle, classes.appCamFilterListItem, classes.cameraCheckBoxLabel, classes.filterGroupDiv, classes.formWrap, classes.formDiv, selectedGroups, activePublic]);
  var handleMapModeChange = (0, _react.useCallback)(function (mode) {
    setMapMode(mode);
    if (mode === 'map') {
      var _map$current18;
      (_map$current18 = map.current) === null || _map$current18 === void 0 ? void 0 : _map$current18.setStyle(MAP_STYLE);
    } else {
      var _map$current19;
      (_map$current19 = map.current) === null || _map$current19 === void 0 ? void 0 : _map$current19.setStyle(_pittaModules.SATELLITE_MAP_STYLE);
    }
    styleChangedRef.current = true;
    setOpenLayer(false);
  }, []);
  var mapTopRightMenuMarkup = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx0["default"])(classes.topControlPane, _defineProperty({}, classes.bottomControlPane, renewal))
    }, /*#__PURE__*/_react["default"].createElement(_TopRightControl.TopRightControl, {
      round: true,
      app: app,
      layerRef: anchorRef,
      publicRef: publicRef,
      onFullscreen: fullscreenIcon ? handleFullscreen : undefined,
      onLayers: renewal ? undefined : function () {
        return setOpenLayer(function (o) {
          return !o;
        });
      },
      onDashcamPublic: publicIcon ? function () {
        app || renewal ? setOpenAppCamFilter(function (o) {
          return !o;
        }) : setOpenCamFilter(function (o) {
          return !o;
        });
      } : undefined,
      fullscreen: fullscreen,
      activePublic: activePublic
      // 필터 변경되었다는 ui 파란점을 보여주기 위한 props
      ,
      activeAppFilter: activePublic && selectedGroups.length === ['notInGroup'].concat(_toConsumableArray(_lodash["default"].map(groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, function (g) {
        return g.GroupID;
      }))).length,
      t: t,
      themeState: themeState
    }), appCamFilterMarkup, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
      open: openCamFilter,
      onClickAway: function onClickAway() {
        return setOpenCamFilter(false);
      },
      anchorEl: publicRef.current,
      placement: "bottom-end",
      modifiers: {
        offset: {
          enabled: true,
          offset: '0, 4px'
        },
        preventOverflow: {
          enabled: false
        }
      },
      classes: {
        root: classes.camFilterRoot
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.camFilterDiv
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.camFilterTitle
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
      category: "Default",
      variant: "SmallBold",
      htmlColor: _pittaModules.LightColors.primary['7']
    }, t('Public'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.camFilterListItem
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
      category: "Default",
      variant: "Body"
    }, t('BlackVue Live Camera')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Switch, {
      checked: activePublic,
      onChange: function onChange(_e, checked) {
        setActivePublic(checked);
      }
    }))))), !mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
      open: openLayer,
      onClickAway: function onClickAway() {
        return setOpenLayer(false);
      },
      anchorEl: anchorRef.current,
      placement: "bottom-end",
      modifiers: {
        offset: {
          enabled: true,
          offset: '0, 4px'
        },
        preventOverflow: {
          enabled: false
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
      className: (0, _clsx0["default"])(_defineProperty({}, classes.tnpDiv, mapMode === 'satellite')),
      startIcon: mapMode === 'map' && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        className: classes.appIcon
      }),
      onClick: function onClick() {
        handleMapModeChange('map');
      }
    }, t('Map')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
      className: (0, _clsx0["default"])(_defineProperty({}, classes.tnpDiv, mapMode === 'map')),
      startIcon: mapMode === 'satellite' && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        className: classes.appIcon
      }),
      onClick: function onClick() {
        handleMapModeChange('satellite');
      }
    }, t('Satellite'))), mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MobileMenu, {
      open: openLayer,
      onClose: function onClose() {
        return setOpenLayer(false);
      },
      container: anchorRef.current,
      classes: {
        root: classes.textTransform
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
      className: classes.mobileMemuItem,
      endIcon: mapMode === 'map' && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        className: classes.appIcon
      }),
      onClick: function onClick() {
        handleMapModeChange('map');
      }
    }, t('Map')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
      className: classes.mobileMemuItem,
      endIcon: mapMode === 'satellite' && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        className: classes.appIcon
      }),
      onClick: function onClick() {
        handleMapModeChange('satellite');
      }
    }, t('Satellite'))));
  }, [classes.topControlPane, classes.gpsChip, classes.gpsChipFullscreen, classes.camFilterRoot, classes.camFilterDiv, classes.camFilterTitle, classes.camFilterListItem, classes.tnpDiv, classes.appIcon, classes.textTransform, classes.mobileMemuItem, app, fullscreenIcon, handleFullscreen, publicIcon, fullscreen, liveGpsUnavailable, activePublic, selectedGroups.length, groupsList === null || groupsList === void 0 ? void 0 : groupsList.DashCamList, appCamFilterMarkup, openCamFilter, t, mobile, openLayer, mapMode, MAP_STYLE]);
  var mapboxMarkup = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: mapContainer,
      className: classes.map
    });
  }, [classes.map]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx0["default"])(classes.root, {
      'ios-map-fullscreen': liveView && fullscreen
    }),
    ref: fullscreen ? mapRef !== null && mapRef !== void 0 ? mapRef : rootDivRef : rootDivRef
  }, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("link", {
    href: "https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css",
    rel: "stylesheet"
  })), mapboxMarkup, app && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.backBtn
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
    size: "small",
    variant: "rounded",
    ref: anchorRef,
    onClick: function onClick() {
      (0, _pittaModules.sendMessageBack)();
    },
    className: (0, _clsx0["default"])(classes.noFocus, _defineProperty({}, classes.noHover, mobile))
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBackIos["default"], {
    className: classes.backIcon
  }))), liveGpsUnavailable && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    className: (0, _clsx0["default"])(classes.gpsChip, _defineProperty({}, classes.gpsChipFullscreen, fullscreen)),
    category: "Default",
    variant: "Small"
  }, t('Live GPS is unavailable')), mapTopRightMenuMarkup, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.ZoomPanel, {
    onMyLocation: function onMyLocation(position) {
      var _map$current20;
      var pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      (_map$current20 = map.current) === null || _map$current20 === void 0 ? void 0 : _map$current20.setCenter(pos);
      setLocationLoading(false);
    },
    onZoomIn: function onZoomIn() {
      var _map$current21;
      return (_map$current21 = map.current) === null || _map$current21 === void 0 ? void 0 : _map$current21.zoomIn();
    },
    onZoomOut: function onZoomOut() {
      var _map$current22;
      return (_map$current22 = map.current) === null || _map$current22 === void 0 ? void 0 : _map$current22.zoomOut();
    },
    hideLocation: true,
    t: t,
    onLoading: function onLoading(v) {
      // throw new Error("Function not implemented.");
      setLocationLoading(v);
    },
    onFailedLocation: function onFailedLocation() {
      _onFailedLocation === null || _onFailedLocation === void 0 ? void 0 : _onFailedLocation();
      setLocationLoading(false);
    },
    loading: locationLoading,
    colors: colors,
    renewal: renewal,
    locPerm: locPerm
  }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
    heading: t('Camera list'),
    open: openCamListModal,
    className: classes.camListPaper,
    titleClassName: classes.camListTitle,
    contentClassName: (0, _clsx0["default"])(classes.camListContent, (_clsx9 = {}, _defineProperty(_clsx9, classes.camListScrollContent, modalLocs.length >= 10), _defineProperty(_clsx9, classes.camListAPPMobileContent, app || mobile), _clsx9)),
    headingTextClassName: classes.camListHeading,
    onClickAway: function onClickAway() {
      return setOpenCamListModal(false);
    },
    content:
    /*#__PURE__*/
    // 10개 미만의 카메라 갯수가 리스트 팝업으로 뜰때는 상하의 크기가 자동 조절될 수 있도록 height추가(Leehj)
    // 모바일,앱인경우 하단의 회색선이 출력되지 않아 width : "fit-content"추가(Leehj)
    _react["default"].createElement(_reactVirtualized.AutoSizer, {
      style: {
        height: 'fit-content',
        //  13187번 이슈 해결을 위해 width: "fit-content" -> width: "100%"로 변경
        //  width: "fit-content"
        width: '100%'
      }
    }, function (_ref3) {
      var height = _ref3.height,
        width = _ref3.width;
      return /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.ScrollBar, {
        style: {
          width: width,
          // 10개 미만의 카메라 갯수가 리스트 팝업으로 뜰때는 상하의 크기가 자동 조절될 수 있도록 적용(Leehj)
          height: modalLocs.length >= 10 ? height : 'fit-content',
          overflowX: 'hidden',
          flex: 1
        }
      }, _lodash["default"].map(modalLocs, function (loc, index) {
        // const deviceInfo = _.find(
        //   cameraList?.deviceListInfo,
        //   (camera: { device: ICameraInfo }) => {
        //     return camera.device.psn === loc.psn;
        //   }
        // );

        // if (deviceInfo?.device.reg_category === "wifi") {
        //   return null;
        // }

        // console.log(
        //   "handleLiveView",
        //   "modalLocs",
        //   index,
        //   "loc",
        //   loc
        // );
        return /*#__PURE__*/_react["default"].createElement(_CameraListItem.CameraListItem, {
          t: t,
          key: loc.psn,
          loc: loc,
          index: index,
          onClick: function onClick() {
            handleLiveview(loc);
          },
          last: index === modalLocs.length - 1,
          colors: colors
        });
      }));
    })
  }));
});
exports.MapboxLocationMap = MapboxLocationMap;